<div
  class="matrix_layoutMain matrix_layoutUseMatrix container matrix_layoutImageEditorContainer"
>
  <div class="row">
    <div class="col-md-9 matrix_layoutMatrixContainerColMain">
      <div class="matrix_productPartsMainContainer matrix_table">
        <appImageEditor></appImageEditor>
      </div>
      <div
        class="matrix_productPartsMainContainer matrix_table matrix_table_gallery"
      >
        <appImageEditorGalleries></appImageEditorGalleries>
      </div>
      <div class="matrix_summaryInformation">
        <appSummaryTable></appSummaryTable>
        <appInformationTable></appInformationTable>
      </div>
    </div>
    <div class="col-md-3 matrix_layoutMatrixContainerColSidebar">
      <appOptionsTable>
        <appOptionsContainer></appOptionsContainer>
        <appInputCustomFormatInsert></appInputCustomFormatInsert>
      </appOptionsTable>
      <appAddToCartButton
        class="matrix_addToCartButtonMain"
      ></appAddToCartButton>
      <appQuantityTable>
        <appQuantityContainer></appQuantityContainer>
        <appInputQuantity></appInputQuantity>
      </appQuantityTable>
      <appSteckdosen></appSteckdosen>
      <appCornersEditor></appCornersEditor>
      <appCutouts></appCutouts>
      <appOtherOptionsTable>
        <appOtherOptionsContainer></appOtherOptionsContainer>
      </appOtherOptionsTable>
      <appUploadTable alwaysShow="true"></appUploadTable>
    </div>
  </div>
  <appImageEditorInputs></appImageEditorInputs>
</div>
